import { render, staticRenderFns } from "./UsersTile.vue?vue&type=template&id=2bbb8652&scoped=true&lang=pug&"
import script from "./UsersTile.vue?vue&type=script&lang=js&"
export * from "./UsersTile.vue?vue&type=script&lang=js&"
import style0 from "./UsersTile.vue?vue&type=style&index=0&id=2bbb8652&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbb8652",
  null
  
)

export default component.exports